import type { Container } from 'pixi.js';
import type { MenuIcon } from '../types';

export class HomePageIconPositionHandler {
  private readonly activeIcons: (MenuIcon | null)[] = [];

  private readonly icons: MenuIcon[] = [];

  constructor(private readonly slot: Container) {}

  public addIcon(icon: MenuIcon): void {
    this.icons.push(icon);
    icon.props({ parent: this.slot });

    icon.onVisibilityChanged.connect(() => {
      this.checkIconVisibility(icon);
    });
    this.checkIconVisibility(icon);
  }

  private checkIconVisibility(icon: MenuIcon): void {
    const iconIndex = this.icons.indexOf(icon);
    this.activeIcons[iconIndex] = icon.isVisible() ? icon : null;
    this.refresh();
  }

  private refresh(): void {
    (this.activeIcons.filter(Boolean) as MenuIcon[]).forEach((icon, index) => {
      icon.props({
        y: index * 140,
      });
    });
  }
}
